import { createParentComponent, type GaVueComponent } from "@/common/vueUtils";
import type { ExploreNavigationItem, ExploreNavigationProps } from "@newgenerated/shared/schema";
import "./_exploreNavigation.scss";

const NavigationCollapseItem = createParentComponent<{ navigation: ExploreNavigationItem; collapsed: boolean; collapsable: boolean }>((props) => {
  const target = `navigation-collapse-${props.navigation.title.toLowerCase().replace(/\s+/g, "")}`;
  return (
    <li class="explore__navigation-item text-nowrap">
      <div class="explore__navigation-item__nav d-flex btn-group" role="group">
        <a class={`explore__navigation-item__nav--link ${props.navigation.selected ? "selected" : ""}`} href={props.navigation.url} type="button">
          <strong>{props.navigation.title}</strong>
        </a>
        <a
          class={`explore__navigation-item__nav--collapse ${props.collapsable ? "" : "hide"}`}
          type="button"
          href={`#${target}`}
          aria-expanded={!props.collapsed || props.navigation.selected}
          aria-hidden="true"
          data-bs-toggle="collapse"
          data-bs-target={`#${target}`}
          aria-controls={target}>
          <i class="ico-chevron-right"></i>
        </a>
      </div>
      {props.children !== undefined ? (
        <div class={`collapse ${!props.collapsed || props.navigation.selected ? "show" : ""}`} id={target} data-bs-parent="#explore__navigation">
          {props.children}
        </div>
      ) : null}
    </li>
  );
});

const NavigationItem = (props: { navigation: ExploreNavigationItem }): GaVueComponent => {
  return (
    <li class="explore__navigation-item text-nowrap ps-3">
      <a type="button" href={props.navigation.url} class={`explore__navigation-item--link explore__navigation-item--sub ${props.navigation.selected ? "selected" : ""}`}>
        {props.navigation.title}
      </a>
    </li>
  );
};

const NavigationGroup = createParentComponent((props) => {
  return <ul role="list">{props.children}</ul>;
});

export const ExploreNavigation = (props: { exploreNavigationProps: ExploreNavigationProps }): GaVueComponent => {
  return (
    <aside class="explore__navigation d-none d-lg-block pe-3" id="explore__navigation">
      <nav>
        <div class="explore__navigation-header">
          <a type="button" class="explore__navigation-header--link" href={props.exploreNavigationProps.url}>
            <strong>{props.exploreNavigationProps.title.toUpperCase()}</strong>
          </a>
        </div>
        <NavigationGroup>
          {props.exploreNavigationProps.navigationItems.map((level1) => {
            return (
              <NavigationCollapseItem navigation={level1.item} collapsed={level1.subItems.find((i) => i.item.selected) === undefined} collapsable={level1.subItems.length > 0}>
                <NavigationGroup>
                  {level1.subItems.map((level2) => {
                    return <NavigationItem navigation={level2.item} />;
                  })}
                </NavigationGroup>
              </NavigationCollapseItem>
            );
          })}
        </NavigationGroup>
      </nav>
    </aside>
  );
};
